const checkDoAllowChangeOrCancelFlight = (bookingResponse, doAllowCancellingTicketedFlight) => {
  if (!bookingResponse) return true;

  if (!bookingResponse.isTicketed) return true;

  if (bookingResponse.isTicketed && doAllowCancellingTicketedFlight) return true;

  return false;
};

export default checkDoAllowChangeOrCancelFlight;
